import Vue from "vue";

import {
    UPDATE_REPORTED,
    FETCH_REPORTED,
    REPORTED_RESET_STATE
} from "./actions.type";

import { FETCH_START, FETCH_END, RESET_STATE } from "./mutations.type";
import { ReportedService } from "../../common/reported.service";

const state = {
    reported: [],
    isLoading: true
};

const initialState = {
    reported: {
        others: "",
        note: "",
        defect_solutions: []
    }
};

const getters = {
    reported(state) {
        return state.reported;
    },
    isLoading(state) {
        return state.isLoading;
    }
};

const actions = {
    [FETCH_REPORTED]({ commit }, params) {
        commit(FETCH_START);
        return ReportedService.query(params)
            .then(({ data }) => {
                data.defect_solutions = data.defect_solutions || [];
                commit(FETCH_END, data);
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    [UPDATE_REPORTED]({ state }) {
        return ReportedService.update(state.reported.id, state.reported);
    },
    [REPORTED_RESET_STATE]({ commit }) {
        commit(RESET_STATE);
    }
};

const mutations = {
    [FETCH_START](state) {
        state.isLoading = true;
    },
    [FETCH_END](state, reported) {
        state.reported = reported;
        state.isLoading = false;
    },
    [RESET_STATE]() {
        for (let f in state) {
            Vue.set(state, f, initialState[f]);
        }
    }
};

export default {
    getters,
    actions,
    state,
    mutations
};
